import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    compras: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    filtroOpcion: 1,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    proveedor: null,
    numeroPresupuesto: 0,
    numeroOrdenProveedor: 0,
    sortByDescending: false,

    compraDatos: [],
    compraCuentasDatos: [],
    compraRenglonesDatos: [],
    compraRemitosDatos: [],
    compraPercepcionesDatos: [],
    compraViaticoDatos: [],
    compraAmortizacionDatos: [],
    compraPresupuestosComisionesDatos: [],

    comprasXls: [],
    rptCompras: [],

    fechaImputacion: '1900-01-01'
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES' (state) {
        state.compras = [];
        /* Paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
        /* Filtro */
        state.filtroOpcion = 1;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.proveedor = null;
        state.numeroPresupuesto = 0;
        state.numeroOrdenProveedor = 0;
        state.sortByDescending = false;
    },

    'INICIALIZAR_COMPRAS' (state) {
        state.compras = [];
    },
    'SET_COMPRAS' (state, compras) {
        state.compras = compras;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_DATOS' (state) {
        state.compraDatos = [];
        state.compraCuentasDatos = [];
        state.compraRenglonesDatos = [];
        state.compraRemitosDatos = [];
        state.compraPercepcionesDatos = [];
        state.compraViaticoDatos = [];
        state.compraAmortizacionDatos = [];
        state.compraPresupuestosComisionesDatos = [];
    },
    'SET_COMPRA_DATOS' (state, params) {
        state.compraDatos = params.compraDatos;
        state.compraCuentasDatos = params.compraCuentasDatos;
        state.compraRenglonesDatos = params.compraRenglonesDatos;
        state.compraRemitosDatos = params.compraRemitosDatos;
        state.compraPercepcionesDatos = params.compraPercepcionesDatos;
        state.compraViaticoDatos = params.compraViaticoDatos;
        state.compraAmortizacionDatos = params.compraAmortizacionDatos;
        state.compraPresupuestosComisionesDatos = params.compraPresupuestosComisionesDatos;
    },

    'INICIALIZAR_COMPRAS_XLS' (state) {
        state.comprasXls = [];
    },
    'SET_COMPRAS_XLS' (state, compras) {
        state.comprasXls = compras;
    },

    'INICIALIZAR_RPT_COMPRAS' (state) {
        state.rptCompras = [];
    },
    'SET_RPT_COMPRAS' (state, rptCompras) {
        state.rptCompras = rptCompras;
    },

    'INICIALIZAR_FECHA_IMPUTACION' (state) {
        state.fechaImputacion = '1900-01-01';
    },
    'SET_FECHA_IMPUTACION' (state, fechaImputacion) {
        state.fechaImputacion = moment(fechaImputacion).format('YYYY-MM-DD');
    },
};

const getters = {
    getField,

    rptCompras (state) {
        return state.rptCompras;
    },
    fechaImputacion (state) {
        return state.fechaImputacion;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },

    getCompras ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COMPRAS');

            let queryString = '?pageSize=' + state.registrosPorPagina
            + '&pageNumber=' + state.paginaActual;

            if (parseInt(state.filtroOpcion) == 1) {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');

                if (state.proveedor) {
                    if (state.proveedor.id != 0) {
                        queryString += '&proveedorId=' + state.proveedor.id;
                    }
                }
            }

            if (parseInt(state.filtroOpcion) == 2) {
                let numeroPresupuesto = -1;
                if (state.numeroPresupuesto) {
                    if (state.numeroPresupuesto != 0) {
                        numeroPresupuesto = state.numeroPresupuesto;
                    }
                }
                queryString += '&numeroPresupuesto=' + numeroPresupuesto;
            }

            if (parseInt(state.filtroOpcion) == 3) {
                let numeroOrdenProveedor = -1;
                if (state.numeroOrdenProveedor) {
                    if (state.numeroOrdenProveedor != 0) {
                        numeroOrdenProveedor = state.numeroOrdenProveedor;
                    }
                }
                queryString += '&numeroOrdenProveedor=' + numeroOrdenProveedor;
            }

            apiAxios.get('compras' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_COMPRAS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, compraId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`compras/${compraId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    getDatos ( { commit, rootState }, compraId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            commit('INICIALIZAR_DATOS');

            if (compraId) {
                apiAxios.get(`compras/${compraId}` )
                    .then(res => {
                        let formatoDocumentoNumero = '';
                        switch (res.data.documentoTipoId) {
                            case 2:
                                formatoDocumentoNumero = 'cuit';
                                break;
                            case 4:
                                formatoDocumentoNumero = 'ein';
                                break;
                        }

                        let total = helpers.methods.formattedMoneda(res.data.total, res.data.moneda);

                        let compraDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha Ingreso', 'valor': res.data.fechaRegistro, 'formato': 'fechaHora' },
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha de Comp.', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            { 'nombre': 'fechaVencimiento', 'campo': 'Fecha de Venc.', 'valor': res.data.fechaVencimiento, 'formato': 'fecha' },
                            { 'nombre': 'periodo', 'campo': 'Periodo', 'valor': res.data.periodo, 'formato': 'periodo' },
                            { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                            { 'nombre': 'condicionFiscal', 'campo': 'Cond. Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                            { 'nombre': 'documentoTipo', 'campo': 'Tipo Identificación', 'valor': res.data.documentoTipo, 'formato': 'cuit' },
                            { 'nombre': 'documentoNumero', 'campo': 'Cod.Identificación', 'valor': res.data.documentoNumero, 'formato': formatoDocumentoNumero },
                            // { 'nombre': 'cuit', 'campo': 'CUIT', 'valor': res.data.cuit, 'formato': 'cuit' },
                            { 'nombre': 'comprobante', 'campo': 'Comprobante', 'valor': res.data.comprobante, 'formato': '' },
                            { 'nombre': 'numero', 'campo': 'Numero', 'valor': res.data.numero, 'formato': '' },
                            // { 'nombre': 'moneda', 'campo': 'Moneda', 'valor': res.data.moneda, 'formato': '' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                        ]

                        // if (parseFloat(res.data.cotizacion) != 1) {
                        //     compraDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotizacion USD', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        // }

                        if (res.data.monedaId != 101) {
                            compraDatos.push({ 'nombre': 'cotizacion', 'campo': `Cotización ${res.data.monedaAbreviacion}`, 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }

                        compraDatos.push(
                            { 'nombre': 'montoGravado', 'campo': 'Monto Gravado', 'valor': res.data.montoGravado, 'formato': 'moneda' },
                            { 'nombre': 'montoNoGravado', 'campo': 'Monto No Gravado', 'valor': res.data.montoNoGravado, 'formato': 'moneda' },
                            { 'nombre': 'montoIvaInscripto', 'campo': 'Monto Iva', 'valor': res.data.montoIvaInscripto, 'formato': 'moneda' },
                            { 'nombre': 'montoExento', 'campo': 'Monto Exento', 'valor': res.data.montoExento, 'formato': 'moneda' },
                        );

                        if (paisId == 1) {
                            compraDatos.push(
                                { 'nombre': 'montoPercepcionIva', 'campo': 'Monto Percepción Iva', 'valor': res.data.montoPercepcionIva, 'formato': 'moneda' },
                                { 'nombre': 'montoPercepcionGanancias', 'campo': 'Monto Percepción Ganancias', 'valor': res.data.montoPercepcionGanancias, 'formato': 'moneda' },
                                { 'nombre': 'montoPercepcionComercioIndustria', 'campo': 'Monto Percepción Com. e Industria', 'valor': res.data.montoPercepcionComercioIndustria, 'formato': 'moneda' },
                                { 'nombre': 'montoPercepcionesProvinciales', 'campo': 'Monto Percepción IIBB', 'valor': res.data.montoPercepcionesProvinciales, 'formato': 'moneda' },
                            )
                        }

                        compraDatos.push(
                            { 'nombre': 'montoOtrosImpuestos', 'campo': 'Monto Otros Impuestos/Percepciones', 'valor': res.data.montoOtrosImpuestos, 'formato': 'moneda' },
                        )

                        if (res.data.monedaId != 101) {
                            compraDatos.push(
                                { 'nombre': 'montoTotal', 'campo': 'Monto Total', 'valor': res.data.montoTotal, 'formato': 'moneda' },
                            )
                        }

                        compraDatos.push(
                            { 'nombre': 'cancelaSaldo', 'campo': 'Cancela Saldo', 'valor': res.data.cancelaSaldo ? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' }
                        )

                        if (res.data.ventaNegociada) {
                            if (res.data.ventaNegociada.trim() != '') {
                                compraDatos.push({ 'nombre': 'ventaNegociada', 'campo': 'Comisión Venta Negociada', 'valor': res.data.ventaNegociada, 'formato': '' })
                            }
                        }

                        if (res.data.ordenFacturacionLogisticaId) {
                            if (res.data.ordenFacturacionLogisticaId != 0) {
                                compraDatos.push({ 'nombre': 'ordenFacturacionLogisticaId', 'campo': 'Orden de Fact. Logística', 'valor': res.data.ordenFacturacionLogisticaId, 'formato': '' })
                            }
                        }

                        let compraViaticoDatos = [];
                        if (res.data.viatico) {
                            compraViaticoDatos = [
                                { 'nombre': 'fechaSolicitud', 'campo': 'Fecha Solicitud', 'valor': res.data.viatico.fechaSolicitud, 'formato': 'fecha' },
                                { 'nombre': 'personal', 'campo': 'Personal', 'valor': res.data.viatico.personal, 'formato': '' },
                                { 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.viatico.importe, 'formato': 'moneda' },
                                { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.viatico.observaciones, 'formato': '' }
                            ]
                        }

                        let compraAmortizacionDatos = [];
                        if (res.data.amortizacionAnios != 0) {
                            compraAmortizacionDatos = [
                                { 'nombre': 'amortizacionAnios', 'campo': 'Amortización - Años', 'valor': res.data.amortizacionAnios, 'formato': '' }
                            ]
                        }

                        let params = {
                            compraDatos,
                            compraCuentasDatos: res.data.cuentas,
                            compraRenglonesDatos: res.data.renglones,
                            compraRemitosDatos: res.data.remitos,
                            compraPercepcionesDatos: res.data.percepcionesProvinciales,
                            compraViaticoDatos,
                            compraAmortizacionDatos,
                            compraPresupuestosComisionesDatos: res.data.presupuestosComisiones
                            // moneda: res.data.moneda
                        }

                        commit('SET_COMPRA_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
    getFechaImputacion ( { commit }, compraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FECHA_IMPUTACION');

            apiAxios.get(`compras/${compraId}/fecha-imputacion-indicadores`)
                .then(res => {
                    commit('SET_FECHA_IMPUTACION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarFechaImputacion ( {}, params ) {
        return new Promise((resolve, reject) => {
            let datos = {
                fecha: params.fechaImputacion
            }
            apiAxios.post(`compras/${params.compraId}/actualizar-imputacion-indicadores`, datos)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptCompras ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_COMPRAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if (params.proveedorId) {
                if (params.proveedorId != 0) {
                    queryString += '&proveedorId=' + params.proveedorId;
                }
            }

            apiAxios.get('compras/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT_COMPRAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptComprasFecha ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_COMPRAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if (params.proveedorId) {
                if (params.proveedorId != 0) {
                    queryString += '&proveedorId=' + params.proveedorId;
                }
            }

            apiAxios.get('compras/rpt/fecha' + queryString)
                .then(res => {
                    commit('SET_RPT_COMPRAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptComprasGastos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_COMPRAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD')
                + '&opcionReporte='+ params.opcionReporte;

            if (params.proveedorId) {
                if (params.proveedorId != 0) {
                    queryString += '&proveedorId=' + params.proveedorId;
                }
            }
            if (params.transportes) {
                if ((/true/i).test(params.transportes)) {
                    queryString += '&transportes=true';
                }
            }
            if (params.presupuestosCerrados) {
                if ((/true/i).test(params.presupuestosCerrados)) {
                    queryString += '&presupuestosCerrados=true';
                }
            }

            let url = 'compras/rpt/compras-gastos';
            if ((/true/i).test(params.reporteDevengado)) {
                url = 'compras/rpt/compras-gastos/devengado';
            }

            apiAxios.get(url + queryString)
                .then(res => {
                    commit('SET_RPT_COMPRAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptOrdenesRemitos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_COMPRAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            // if (params.proveedorId) {
            //     if (params.proveedorId != 0) {
            //         queryString += '&proveedorId=' + params.proveedorId;
            //     }
            // }

            apiAxios.get('compras/rpt/ordenes-remitos' + queryString)
                .then(res => {
                    commit('SET_RPT_COMPRAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
